<template>
	<div class="header">
		<div class="collapse-btn" @click="collapseChage">
			<svg v-if="!collapse" viewBox="0 0 1024 1024" width="20" height="20" fill="currentColor">
				<path d="M128 192h768a42.666667 42.666667 0 0 1 0 85.333333H128a42.666667 42.666667 0 0 1 0-85.333333z m0 277.333333h768a42.666667 42.666667 0 0 1 0 85.333334H128a42.666667 42.666667 0 0 1 0-85.333334z m0 277.333334h768a42.666667 42.666667 0 0 1 0 85.333333H128a42.666667 42.666667 0 0 1 0-85.333333z"/>
			</svg>
			<svg v-else viewBox="0 0 1024 1024" width="20" height="20" fill="currentColor">
				<path d="M128 192h768a42.666667 42.666667 0 0 1 0 85.333333H128a42.666667 42.666667 0 0 1 0-85.333333z m0 277.333333h341.333333a42.666667 42.666667 0 0 1 0 85.333334H128a42.666667 42.666667 0 0 1 0-85.333334z m0 277.333334h768a42.666667 42.666667 0 0 1 0 85.333333H128a42.666667 42.666667 0 0 1 0-85.333333z"/>
			</svg>
		</div>
		<div class="header-right">
			<div class="header-user-con">
				<div class="complaint-notice" v-show="countDataValue">
					<div @click="toHistoryComplaint" style="display: flex;align-items: center;">
						<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" style="margin-right: 3px;">
							<path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
						</svg>
						通知：12321今天已受理 {{ countDataValue }} 条投诉
					</div>
					<svg @click.stop="refreshCountData" viewBox="0 0 1024 1024" width="14" height="14" fill="currentColor" style="margin-left: 8px;cursor: pointer;">
						<path d="M934.4 193.6v227.2c0 17.6-14.4 32-32 32h-227.2c-25.6 0-38.4-30.4-20.8-48l81.6-81.6C681.6 268.8 576 240 480 240c-176 0-320 144-320 320s144 320 320 320c140.8 0 262.4-91.2 304-217.6 6.4-20.8 27.2-33.6 48-27.2 20.8 6.4 33.6 27.2 27.2 48C800 816 651.2 928 480 928c-246.4 0-448-201.6-448-448s201.6-448 448-448c116.8 0 225.6 44.8 307.2 126.4l76.8-76.8c17.6-17.6 48-5.6 48 20.8v16z"/>
					</svg>
				</div>
				<div class="download-box" v-if="ms_role === 'admin'" @click="towoniuRecharge">
					<i class="el-icon-bell" v-if="total > 0"
						style="font-size: 20px;cursor: pointer;color: #E74c3c;"></i>
					<i class="el-icon-bell" v-else style="font-size: 20px;cursor: pointer;" :class="[theme3]"></i>
					<span style="cursor: pointer;">系统提醒</span>
				</div>
				<div class="download-box" v-if="deviceName == null">
					<i class="el-icon-s-platform" style="font-size: 20px;" :class="[theme3]"></i>
					<span>未连接设备</span>
				</div>
				<div class="download-box" v-else>
					<i class="el-icon-s-platform" style="font-size: 20px;" :class="[theme3]"></i>
					<span style=" color: #67C23A;">已连接{{ deviceName }}设备</span>
				</div>
				<div class="download-box" v-if="setCallStatus">
					<i class="el-icon-s-platform" style="font-size: 20px;" :class="[theme3]"></i>
					<span style=" color: #67C23A;">话机{{setCallStatus}}</span>
				</div>
				<div class="download-box">
					<i class="el-icon-mobile-phone" style="font-size: 20px;" :class="[theme3]"></i>
					下载APP
					<div class="img-box">
						扫码下载app
						<img :src="webInfo.downUrl" alt="" />
					</div>
				</div>
				<SettingDrawer />
				<!-- 用户头像 -->
				<div class="user-avator"><img :src="headerUrl" /></div>
				<!-- 用户名下拉菜单 -->
				<el-dropdown class="user-name" trigger="click" @command="handleCommand">
					<span class="el-dropdown-link">
						{{ username }}
						<i class="el-icon-caret-bottom"></i>
					</span>
					<template #dropdown>
						<el-dropdown-menu>
							<el-dropdown-item divided command="editPassword">修改密码</el-dropdown-item>
							<el-dropdown-item divided command="task">任务中心</el-dropdown-item>
							<el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
						</el-dropdown-menu>
					</template>
				</el-dropdown>
			</div>
		</div>
	</div>
	<el-dialog title="修改密码" v-model="addVisible" width="30%" @close="closeDialog('form')">
		<el-form :model="form" :rules="rules" ref="form" label-width="100px">
			<el-form-item label="账号" prop="account"><el-input size="small" v-model="form.account"
					disabled></el-input></el-form-item>
			<el-form-item label="原密码" prop="oldPassword"><el-input size="small"
					v-model="form.oldPassword"></el-input></el-form-item>
			<el-form-item label="新密码" prop="newPassword"><el-input size="small"
					v-model="form.newPassword"></el-input></el-form-item>
			<el-form-item label="密码确认" prop="checkPass"><el-input size="small"
					v-model="form.checkPass"></el-input></el-form-item>
			<el-form-item class="dis-end">
				<el-button size="small" @click="closeDialog('form')">取消</el-button>
				<el-button size="small" type="primary" :class="[theme]" @click="confirmEdit('form')">确定</el-button>
			</el-form-item>
		</el-form>
	</el-dialog>
	<audio id="audioID1" ref="audio" class="aud" @ended="audioEnded">
		<source :src="audioUrl1" />
	</audio>
	<!-- 通知组件 -->
	<div class="notification" :class="[notification.type, { show: showNotification }]">
		<i :class="notification.icon"></i>
		<i class="el-icon-close" style="color: #ccc;font-size: 22px;position: absolute;top:4px;right: -20px;"
			@click="closeShowNotification"></i>
		<div class="notification-content">
			<h4>{{ notification.name }}</h4>
			<h4 style="margin: 10px 0;">{{ notification.phone }}</h4>
			<p>{{ notification.message }}</p>
		</div>
	</div>
</template>
<script>
	import {
		modifyPassword
	} from '../api/userIndex';
	import {
		webGetHeadPortrait,
		getConnection,
		getcount,
		getUserInfo
	} from '../api/sumIndex.js';
	import {
		getOemInfo
	} from '../api/index.js';
	import {
		syncLocalStorage
	} from '@/utils/storage';
	import axios from 'axios';
	import SettingDrawer from './Setting/index.vue';
	import {
		findCallBack,
		deleteCallBack,
		addCallBack
	} from '../api/agentIndex.js';
	export default {
		components: {
			SettingDrawer
		},
		data() {
			var validateOldPass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入原密码'));
				}
				callback();
			};
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入新密码'));
				} else {
					if (this.form.checkPass !== '') {
						this.$refs.form.validateField('checkPass');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.form.newPassword) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				fullscreen: false,
				addVisible: false,
				form: {
					account: localStorage.getItem('ms_username'),
					oldPassword: '',
					newPassword: '',
					checkPass: ''
				},
				name: 'linxin',
				message: 2,
				rules: {
					oldPassword: [{
						validator: validateOldPass,
						trigger: 'blur'
					}],
					newPassword: [{
						validator: validatePass,
						trigger: 'blur'
					}],
					checkPass: [{
						validator: validatePass2,
						trigger: 'blur'
					}]
				},

				headerUrl: '',
				deviceName: null,
				sipStatus: false,
				audioUrl1: 'https://phone-recorder.oss-cn-hangzhou.aliyuncs.com/yunqitongxcx/static/czdd.mp3', //音频资源
				audioOpen: false,
				yuying: null,
				webInfo: '',
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				a: 0,
				total: '',
				customData: '',
				ms_role: localStorage.getItem('ms_role'),
				countDataValue: '',
				countDataTime: '',



				value: new Date(),
				reminders: [],
				showReminderModal: false,
				currentReminder: this.getEmptyReminder(),
				isEditing: false,
				showNotification: false,
				notification: {
					name: '',
					phone: '',
					message: '',
					icon: '',
					type: ''
				},
				currentMonth: '',
				currentYear: '',
				currentTime: '00:00:00',
				timer: null,
			};
		},
		watch: {
			// 监听日历变化更新标题
			value() {
				this.$nextTick(() => {
					this.updateCalendarTitle();
				});
			}
		},
		computed: {
			username() {
				let username = localStorage.getItem('ms_username');
				return username ? username : this.name;
			},
			collapse() {
				return this.$store.state.collapse;
			},
			setCallStatus() {
				return this.$store.state.setCallStatus;
			},
			filteredReminders() {
				return [...this.reminders].sort((a, b) => {
					const dateA = new Date(`${a.date} ${a.time}`);
					const dateB = new Date(`${b.date} ${b.time}`);

					return dateA - dateB;
				});
			}
		},
		beforeUnmount() {
			if (this.timer) {
				clearInterval(this.timer);
			}
		},
		methods: {
			getcolor1(e) {
				this.theme = localStorage.setItem('theme', e);
			},
			getOEMagentOem() {
				// let url = 'crm.jilinlingshang.com';// 如果改领尚 切换当前的
				let url = window.location.host; // 如果改云企通 切换当前的
				// let url = 'cytx88.cn'; //如果改橙逸 切换当前
				getOemInfo(url)
					.then(res => {
						if (res?.code === 200) {
							this.webInfo = res.data;
							let linkicon = document.querySelector("link[rel*='icon']") || document.createElement(
								'link');
							linkicon.href = res.data.icon;
							localStorage.setItem('webName', res.data.webName);
						} else {
							this.$message.error('查询失败，请稍后再试！');
						}
					})
					.catch(err => {
						this.$message.error('查询失败，请稍后再试！');
					});
			},
			confirmEdit(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						this.loading = true;
						modifyPassword(this.form).then(res => {
							if (res?.code === 200) {
								this.$message.success('修改成功');
								this.handleCommand('loginout');
							} else {
								this.$message.error(res.message);
							}
							this.addVisible = false;
						});
					}
				});
			},
			// 用户名下拉菜单选择事件
			handleCommand(command) {
				if (command === 'loginout') {
					localStorage.removeItem('interior');
					localStorage.removeItem('ms_role');
					localStorage.removeItem('ms_username');
					localStorage.removeItem('user');
					localStorage.removeItem('token');
					localStorage.removeItem('deviceName');
					// localStorage.clear();
					clearInterval(this.yuying);
					this.$router.push('/login');
				}
				if (command === 'editPassword') {
					this.addVisible = true;
				}
				if (command === 'task') {
					this.$router.push('/taskDesk');
				}
			},
			towoniuRecharge() {
				if (this.customData) {
					this.$router.push('/company');
				} else {
					this.$router.push('/woniuRecharge');
				}
			},
			// 跳转到12321投诉趋势页面
			toHistoryComplaint() {
				this.$router.push('/historyComplaint');
			},
			// 刷新12321数据
			refreshCountData() {
				this.getCountData();
			},
			toreturnVisit() {
				this.$router.push('/returnVisit');
			},
			// 侧边栏折叠
			collapseChage() {
				this.$store.commit('hadndleCollapse', !this.collapse);
				// 更新收起按钮位置
				this.$nextTick(() => {
					const btn = document.querySelector('.collapse-btn');
					if (btn) {
						btn.style.left = this.collapse ? '65px' : '226px';
					}
				});
			},
			closeDialog(formName) {
				this.addVisible = false;
				(this.form = {
					account: localStorage.getItem('ms_username')
				}),
				this.resetForm(formName);
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			getConnections() {
				let data = {
					name: localStorage.getItem('ms_username')
				};
				getConnection(data).then(res => {
					if (res.data.deviceName == '') {
						localStorage.removeItem('deviceName');
						localStorage.removeItem('AppInfoIp');
						this.deviceName = null;
					} else {
						localStorage.setItem('AppInfoIp', res.data.ip);
						localStorage.setItem('deviceName', res.data.deviceName);
						this.deviceName = localStorage.getItem('deviceName');
					}
				});
			},
			getcounts() {
				let data = {
					userId: localStorage.getItem('user')
				};
				getcount(data).then(res => {
					this.total = res.data;
					this.customData = res.customData;
					const audio1 = new Audio(
						'https://phone-recorder.oss-cn-hangzhou.aliyuncs.com/yunqitongxcx/static/czdd.mp3');
					const audio2 = new Audio(
						'https://phone-recorder.oss-cn-hangzhou.aliyuncs.com/yunqitongxcx/ttsmaker-file-2025-7-29-11-21-3.wav'
					);
					if (this.total > 0) {
						audio1.play();
					}
					if (this.customData > 0) {
						audio2.play();
					}
				});
			},
			// 更新当前时间
			updateCurrentTime() {
				const now = new Date();
				const hours = now.getHours().toString().padStart(2, '0');
				const minutes = now.getMinutes().toString().padStart(2, '0');
				const seconds = now.getSeconds().toString().padStart(2, '0');
				this.currentTime = `${hours}:${minutes}:${seconds}`;
			},
			// 更新日历标题（月份和年份）
			updateCalendarTitle() {
				const calendar = this.$refs.calendar;
				if (calendar && calendar.curMonthDate) {
					const currentDate = calendar.curMonthDate;
					this.currentMonth = currentDate.getMonth() + 1 + '月';
					this.currentYear = currentDate.getFullYear();
				} else {
					const today = new Date();
					this.currentMonth = today.getMonth() + 1 + '月';
					this.currentYear = today.getFullYear();
				}
			},
			// 获取空提醒对象
			getEmptyReminder() {
				const now = new Date();
				const hours = now.getHours().toString().padStart(2, '0');
				const minutes = now.getMinutes().toString().padStart(2, '0');
				const seconds = now.getSeconds().toString().padStart(2, '0');

				return {
					id: Date.now(),
					name: '',
					date: this.formatDate(new Date()),
					time: '',
					type: 'work',
					remark: ''
				};
			},
			// 检查是否有提醒
			hasReminders(date) {
				if (!date) return false;
				const dateStr = this.formatDate(date);
				return this.reminders.some(r => r.date === dateStr);
			},
			// 检查是否是今天
			isToday(date) {
				if (!date || !(date instanceof Date)) return false;
				const today = new Date();
				return date.getDate() === today.getDate() &&
					date.getMonth() === today.getMonth() &&
					date.getFullYear() === today.getFullYear();
			},

			// 格式化日期
			formatDate(date) {
				if (!date) return '';
				// 如果传入的是字符串，尝试转换为日期对象
				if (typeof date === 'string') {
					date = new Date(date);
				}
				// 检查是否为有效日期
				if (!(date instanceof Date) || isNaN(date.getTime())) {
					return '';
				}
				const year = date.getFullYear();
				const month = (date.getMonth() + 1).toString().padStart(2, '0');
				const day = date.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
			// 打开添加提醒模态框
			openAddReminderModal(date) {
				this.currentReminder = this.getEmptyReminder();
				if (date) {
					this.currentReminder.date = this.formatDate(date);
				}
				this.isEditing = false;
				this.showReminderModal = true;
			},

			// 编辑提醒
			editReminder(reminder) {
				// 将字符串时间转换为时间对象
				const [hours, minutes, seconds] = reminder.time.split(':');
				const time = new Date(0, 0, 0, parseInt(hours), parseInt(minutes), parseInt(seconds));

				this.currentReminder = {
					...reminder,
					time: time
				};
				this.isEditing = true;
				this.showReminderModal = true;
			},

			// 删除提醒
			deleteReminder(id) {
				this.$confirm('确定要删除这个提醒吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					axios.delete('/api/customer/deleteCallBack', {
							params: {
								id: id,
							}
						})
						.then(res => {
							if (res.data.code == 200) {
								this.getFindCallBack()
								this.showNotification = true;
								// this.notification = {
								// 	title: '删除成功',
								// 	message: '提醒事项已删除',
								// 	icon: 'el-icon-success',
								// 	type: ''
								// };
								setTimeout(() => {
									this.showNotification = false;
								}, 3000);
							} else {
								this.$message.error(res.data.message);
							}
						})
						.catch(error => console.error('删除失败', error));
				});
			},

			// 保存提醒
			saveReminder() {
				if (!this.currentReminder.name) {
					this.$message.error('请填写提醒标题');
					return;
				}
				// 从时间对象提取时间
				if (this.currentReminder.time) {
					const hours = this.currentReminder.time.getHours().toString().padStart(2, '0');
					const minutes = this.currentReminder.time.getMinutes().toString().padStart(2, '0');
					const seconds = this.currentReminder.time.getSeconds().toString().padStart(2, '0');
					this.currentReminder.time = `${hours}:${minutes}:${seconds}`;
				} else {
					this.$message.error('请选择有效的时间');
					return;
				}

				let data = {
					name: this.currentReminder.name,
					phone: this.currentReminder.phone,
					remark: this.currentReminder.remark,
					date: this.formatDate(this.currentReminder.date) + ' ' + this.currentReminder.time,
					userId: localStorage.getItem('user'),
				}
				addCallBack(data).then(res => {
					if (res?.code === 200) {
						this.showReminderModal = false;
						this.getFindCallBack();
						setTimeout(() => {
							this.showNotification = false;
						}, 3000);
					} else {
						this.$message.error(res.message);
					}
				});
			},

			// 检查提醒
			checkReminders() {
				const now = new Date();
				const currentTimeStr =
					`${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
				const currentDateStr = this.formatDate(now);
				this.reminders.forEach(reminder => {
					if (reminder.time === currentDateStr + ' ' + currentTimeStr) {
						this.triggerAlarm(reminder);
					}
				});
			},

			// 触发提醒
			triggerAlarm(reminder) {
				console.log(reminder, 'reminderreminder')
				this.showNotification = true;
				this.notification = {
					name: `姓名： ${reminder.name}`,
					phone: `手机号：${reminder.phone}`,
					message: `备注： ${reminder.remark}` || '您有一个提醒事项！',
					icon: 'el-icon-bell',
					type: 'notification-alarm'
				};

				// 播放提示音
				this.playNotificationSound();

			},

			// 播放提示音
			playNotificationSound() {
				const audioContext = new(window.AudioContext || window.webkitAudioContext)();
				const oscillator = audioContext.createOscillator();
				const gainNode = audioContext.createGain();

				oscillator.connect(gainNode);
				gainNode.connect(audioContext.destination);

				oscillator.type = 'sine';
				oscillator.frequency.value = 880;
				gainNode.gain.value = 0.3;

				oscillator.start();
				setTimeout(() => {
					oscillator.stop();
				}, 500);
			},


			closeShowReminderModal() {
				this.showReminderModal = false;
			},
			closeShowNotification() {
				this.showNotification = false;
			},
			getFindCallBack() {
				let data = {
					phone: '',
					userId: localStorage.getItem('user'),
				}
				findCallBack(data).then(res => {
					if (res?.code === 200) {
						this.reminders = res.customData;

					} else {
						this.$message.error(res.message);
					}
				});
			},
			// 获取12321网站抓取数据
			getCountData() {
				let data = {
					currentUserId: localStorage.getItem('user')
				};
				console.log('调用getUserInfo获取12321数据...');
				getUserInfo(data).then(res => {
					console.log('getUserInfo返回:', res);
					if (res?.code === 200 && res.data) {
						this.countDataValue = res.data.countDataValue || '';
						this.countDataTime = res.data.countDataTime || '';
						console.log('countDataValue:', this.countDataValue);
					}
				}).catch(err => {
					console.log('获取12321数据失败', err);
				});
			},
		},
		created() {
			let data = {
				currentUserId: localStorage.getItem('user')
			};
			webGetHeadPortrait(data).then(res => {
				let role = localStorage.getItem('ms_role');
				if (role == 'admin') {
					this.yuying = setInterval(res => {
						this.getcounts();
					}, 8000);
				}
				this.headerUrl = res.data.headPortrait;
				if (res.data.computerDial == true) {
					if (role === 'normal') {
						if (localStorage.getItem('sip') == 'false') {
							setInterval(res => {
								this.getConnections();
							}, 5000);
						}

					}
				}
			});
			this.getOEMagentOem();
			// 获取12321网站抓取数据
			this.getCountData();
		},
		mounted() {
			if (document.body.clientWidth < 1500) {
				this.collapseChage();
			}
			this.getFindCallBack();
			this.updateCalendarTitle();
			// 更新当前时间
			this.updateCurrentTime();
			this.timer = setInterval(() => {
				this.updateCurrentTime();
				this.checkReminders();
			}, 1000);
		},

	};
</script>
<style scoped>
	.header {
		position: relative;
		box-sizing: border-box;
		/* width: calc(100%-226px); */

		height: 70px;
		font-size: 22px;
		color: #666;
	}

	.collapse-btn {
		position: absolute;
		left: 226px;
		top: 0;
		padding: 0 21px;
		cursor: pointer;
		line-height: 70px;
		z-index: 9999;
		transition: left 0.3s ease-in-out;
	}

	.collapse-btn svg {
		vertical-align: middle;
	}

	.header .logo {
		float: left;
		width: 232px;
		height: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		color: #6c6cf9;
		margin-left: 10px;
	}

	.header .logo img {
		width: 100px;
	}

	.header-right {
		float: right;
		padding-right: 25px;
	}

	.header-user-con {
		display: flex;
		height: 70px;
		align-items: center;
	}

	.header-user-con div {
		display: flex;
		height: 70px;
		align-items: center;
	}

	/deep/.el-badge__content.is-fixed {
		top: 18px;
		right: 60px;
	}

	.erweima {
		width: 26px;
		height: 26px;
		overflow: hidden;
	}

	.erweima img {
		width: 100%;
		height: 100%;
	}

	.btn-fullscreen {
		transform: rotate(45deg);
		margin-right: 5px;
		font-size: 24px;
	}

	.btn-bell,
	.btn-fullscreen {
		position: relative;
		width: 30px;
		height: 30px;
		text-align: center;
		border-radius: 15px;
		cursor: pointer;
	}

	.btn-bell-badge {
		position: absolute;
		right: 0;
		top: -2px;
		width: 8px;
		height: 8px;
		border-radius: 4px;
		background: #f56c6c;
		color: #666;
	}

	.btn-bell .el-icon-bell {
		color: #666;
	}

	.user-name {
		margin-left: 10px;
	}

	.user-avator {
		margin-left: 20px;
		margin-right: 10px;
	}

	.user-avator img {
		display: block;
		width: 40px;
		height: 40px;
		border-radius: 50%;
	}

	.el-dropdown-link {
		color: #666;
		cursor: pointer;
	}

	.el-dropdown-menu__item {
		text-align: center;
	}

	.download-box2 {
		position: relative;
		margin-right: 20px;
		cursor: pointer;
	}

	.download-box {
		position: relative;
		margin-right: 10px;
	}

	.complaint-notice {
		cursor: pointer;
		color: #E74c3c;
		font-size: 14px;
		margin-right: 15px;
		display: flex;
		align-items: center;
	}

	.complaint-notice:hover {
		text-decoration: underline;
	}

	.download-box .img-box {
		width: 140px;
		height: 165px;
		background-color: #fff;
		display: none;
		box-shadow: 0 5px 10px #ddd;
	}

	.download-box .img-box img {
		width: 120px;
		margin: 0 10px 10px 10px;
	}

	.download-box:hover {
		color: #4f7afd;
		cursor: pointer;
	}

	.download-box:hover i {
		color: #4f7afd;
	}

	.download-box:hover .img-box {
		text-align: center;
		line-height: 36px;
		display: block;
		position: absolute;
		top: 60px;
		left: -35px;
		color: #000 !important;
		z-index: 999;
	}



	/* 通知样式 */
	.notification {
		position: fixed;
		top: 20px;
		right: 5px;
		background: #ffffff;
		border-left: 4px solid #2ecc71;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		padding: 30px 65px 30px 40px;
		border-radius: 6px;
		z-index: 2000;
		display: flex;
		align-items: center;
		max-width: 350px;
		transform: translateX(120%);
		transition: transform 0.5s ease;
	}

	.notification.show {
		transform: translateX(0);
	}

	.notification i {
		color: #2ecc71;
		font-size: 32px;
		margin-right: 30px;
	}

	.notification-content h4 {
		margin-bottom: 15px;
		color: #2c3e50;
	}

	.notification-content p {
		color: #7f8c8d;
		font-size: 14px;
	}

	.notification-alarm {
		border-left-color: #e74c3c;
	}

	.notification-alarm i {
		color: #e74c3c;
	}
</style>